export interface IRecommendationContact {
  phone: string;
  realtyUserId: number;
  type: EContactType;
}

export enum EContactType {
  Builder = 'builder',
  Seller = 'seller',
}
